var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"rtg-section"}},[_c('div',{staticClass:"ready-to-start-text"},[_vm._v("\n    Ready to get started? Let's find your provider\n  ")]),_c('PrimaryButton',{staticClass:"primarybutton",attrs:{"text":'Find Your Provider'},on:{"clickHandler":_vm.findyourproviderClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }